import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../payment-link-system/PaymentLinkTable";
import { fetchTrainerMembersData } from "../../redux/reducers/apiSlice";
import {
  convertStraight,
  convertTimeRangeHHMMSS,
  convertTo24HourFormat,
} from "../common-data/Converts";
import MemberCheckinLogs from "../pt-trials/common/MemberCheckinLogs";
import ModalHeadAndClose from "../payouts-wtf/common/ModalHeadAndClose";
import MemberTableFilters from "./MemberTableFilters";
import { CheckCircleIcon, CrossCircleIcon } from "../../images/icons/icons";
// import ProfileInfo from "./common/ProfileInfo";

const TrainerMembers = ({
  user,
  prevClickValues,
  prevFilters,
  onClosePrevModal,
}) => {
  const dispatch = useDispatch();
  const { trainerMembers, loading, error } = useSelector((state) => state.api);

  const isAdmin = user?.account_type === "admin";
  const isGym = user?.account_type === "gym";
  const isClusterManager = user?.account_type === "cluster_manager";

  const [isPage, setIsPage] = useState(0);
  const iniAllFilters = {
    selectedGym: prevFilters
      ? prevFilters.selectedGym
      : !isAdmin && !isClusterManager
      ? {
          label: isGym ? user?.name : user?.gym_name || "",
          value: user?.gym_id || user?.uid || user?.user_id || "",
        }
      : "",
    selectedStartDate: prevFilters.selectedStartDate || "",
    selectedEndDate: prevFilters.selectedEndDate || "",
    searchString: "",
    lastCheckedIn: "",
    selectedShift: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilters);
  const iniFilters = {
    page: 0,
    limit: 10,
    gym_id: "",
    search: "",
    trainer_id: prevClickValues.userId,
    shift_start_time: "",
    shift_end_date: "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const iniTbDatas = {
    allData: null,
    pagination: [],
  };
  const [tbDatas, setTbDatas] = useState(iniTbDatas);
  const initialClickValues = {
    isModOpen: false,
    userId: "",
    type: "",
    clickedType: "",
    attendaceDetails: [],
    sendableStatsQPs: "",
  };
  const [clickValues, setClickValues] = useState(initialClickValues);

  const onClickSearch = () => {
    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  const onCloseModal = () => {
    setClickValues(initialClickValues);
  };

  const onClickValues = (e, row, name) => {
    e.preventDefault();

    setClickValues((prevs) => ({
      ...prevs,
      isModOpen: true,
      type: "member",
      clickedType: name,
      attendaceDetails: row?.attandance_details || [],
      rowData: {
        who: "member",
        name: row?.user_name,
        mobile: row?.user_mobile,
        email: row?.user_email,
        gym_name: row?.gym_name,
        last_checkin: row?.last_checkin,
        checkin_time: row?.checkin_time,
        last_checkin_days_ago: row?.last_checkin_days_ago,
      },
    }));
  };

  const onClickReset = () => {
    setAllFilters(iniAllFilters);
    setFilters(iniFilters);
  };

  // useEffect(() => {
  //   setAllFilters((prevs) => ({
  //     ...prevs,
  //     selectedGym: prevFilters
  //       ? prevFilters.selectedGym
  //       : !isAdmin
  //       ? {
  //           label: isGym ? user?.name : user?.gym_name || "",
  //           value: user?.gym_id || user?.uid || user?.user_id || "",
  //         }
  //       : "",
  //   }));
  // }, [user?.gym_id]);

  useEffect(() => {
    if (allFilters.selectedShift && allFilters.selectedShift?.label) {
      const [start, end] = allFilters.selectedShift.label.split("TO");

      const formattedStartTime = start
        ? convertTo24HourFormat(start.trim())
        : "";

      const formattedEndTime = end ? convertTo24HourFormat(end.trim()) : "";

      setFilters({
        ...filters,
        shift_start_time: formattedStartTime,
        shift_end_date: formattedEndTime,
        page: isPage + 1,
        gym_id: allFilters.selectedGym?.value || "",
        start_date: allFilters.selectedStartDate || "",
        end_date: allFilters.selectedEndDate || "",
        last_checkin_days_ago: allFilters.lastCheckedIn?.value || "",
      });
    } else {
      setFilters((prevs) => ({
        ...prevs,
        page: isPage + 1,
        gym_id: allFilters.selectedGym?.value || "",
        start_date: allFilters.selectedStartDate || "",
        end_date: allFilters.selectedEndDate || "",
        last_checkin_days_ago: allFilters.lastCheckedIn?.value || "",
        shift_start_time: "",
        shift_end_date: "",
      }));
    }
  }, [
    isPage,
    allFilters.selectedGym,
    allFilters.selectedStartDate,
    allFilters.selectedEndDate,
    allFilters.lastCheckedIn,
    allFilters.selectedShift,
  ]);

  useEffect(() => {
    if (filters?.trainer_id) {
      dispatch(
        fetchTrainerMembersData({
          filters: filters,
          token: user?.token,
        })
      );
    }
  }, [filters]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
    }
  }, [allFilters.searchString]);

  useEffect(() => {
    if (trainerMembers?.status && trainerMembers?.data && !error) {
      setTbDatas((prevs) => ({
        ...prevs,
        allData: trainerMembers.data,
        pagination: trainerMembers?.pagination || [],
      }));
    } else {
      setTbDatas(iniTbDatas);
    }
  }, [trainerMembers, error]);

  const tbColumns = [
    {
      dataField: "user_name",
      text: "member details",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.user_name || "NA"} <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.user_mobile || ""}
              <br />
              {row?.user_email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "is_biomax_registered",
      text: "Biomax Register",
      formatter: (cell, row) => {
        return (
          <span className="tb-data icon">
            {row?.is_biomax_registered === "true" ? (
              <CheckCircleIcon />
            ) : (
              <CrossCircleIcon />
            )}
          </span>
        );
      },
    },
    {
      dataField: "last_checkin",
      text: "Last Checkin",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data minWidth150 link"
            style={{
              textDecoration: "underline",
              fontWeight: "700",
              cursor: "pointer",
            }}
            onClick={() =>
              setClickValues((prevs) => ({
                ...prevs,
                userId: row?.user_id,
                isModOpen: true,
                type: "member",
                sendableStatsQPs: `&start_date=${
                  row?.last_checkin || ""
                }&end_date=${row?.last_checkin || ""}`,
              }))
            }
          >
            {convertStraight(row?.last_checkin) || "-"}
            <br />
            {convertTimeRangeHHMMSS(row?.checkin_time) || ""}
            <br />
            {row?.last_checkin_days_ago
              ? `(${row.last_checkin_days_ago?.replace(/_/g, " ")})`
              : ""}
          </span>
        );
      },
    },
  ];

  const attendanceTbCols = [
    {
      dataField: "checkin_date",
      text: "checkin date",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.checkin_date ? convertStraight(row.checkin_date) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "checkin_time",
      text: "checkin time",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.checkin_time ? convertTimeRangeHHMMSS(row.checkin_time) : "-"}
          </span>
        );
      },
    },
  ];

  return (
    <>
      {/* CHECKIN LOGS */}
      <Modal
        isOpen={clickValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Checkin Details Modal"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer minWidth80vw">
          <ModalHeadAndClose
            title={`${clickValues.type} Checkin Logs`}
            onClose={onCloseModal}
          />

          {clickValues.clickedType === "attendance_details" ? (
            <>
              {/* <ProfileInfo info={clickValues.rowData} /> */}
              <div className="modalHeadAndCloseContainer mod-with-details">
                <div className="user-info">
                  <div className="user-details">
                    <span className="mod-header">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="33"
                        height="33"
                        viewBox="0 0 33 33"
                        fill="none"
                        onClick={onCloseModal}
                      >
                        <g id="navigate_before">
                          <path
                            id="icon"
                            d="M19.25 24.75L11 16.5L19.25 8.25L21.175 10.175L14.85 16.5L21.175 22.825L19.25 24.75Z"
                            fill="#1D1B20"
                          />
                        </g>
                      </svg>
                      {clickValues.rowData?.name || "NA"}
                    </span>
                    <span className="mod-regular-text underline">
                      +91 {clickValues.rowData?.mobile || ""}
                    </span>
                    <span className="mod-regular-text lowercase underline">
                      {clickValues.rowData?.email || ""}
                    </span>
                    <span className="mod-light-text">
                      {clickValues.rowData?.gym_name || ""}
                    </span>
                    <span className="mod-light-text underline">
                      Shift - {clickValues.rowData?.shiftTiming || ""}
                    </span>
                    <span className="mod-light-text underline">
                      Last Checked In -{" "}
                      {convertStraight(clickValues.rowData?.last_checkin) ||
                        "-"}{" "}
                      {convertTimeRangeHHMMSS(
                        clickValues.rowData?.checkin_time
                      ) || ""}{" "}
                      {clickValues.rowData?.last_checkin_days_ago
                        ? `(${clickValues.rowData.last_checkin_days_ago?.replace(
                            /_/g,
                            " "
                          )})`
                        : ""}
                    </span>
                  </div>
                </div>

                <button
                  type="button"
                  className="closeModalBtn"
                  onClick={onCloseModal}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-x-lg"
                    viewBox="0 0 16 16"
                  >
                    <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" />
                  </svg>
                </button>
              </div>

              <div className="tab-view-table-container overflowAuto separatedTable mt30">
                <PaymentLinkTable
                  tableData={clickValues.attendaceDetails}
                  tableColumns={attendanceTbCols}
                />
              </div>
            </>
          ) : (
            <MemberCheckinLogs
              clickValues={clickValues}
              sendableStatsQPs={clickValues.sendableStatsQPs}
            />
          )}
        </div>
      </Modal>
      {/* ------------- CHECKIN LOGS ----------------- */}

      {/* <ProfileInfo info={prevClickValues.rowData} /> */}
      <div className="modalHeadAndCloseContainer mod-with-details">
        <div className="user-info">
          <div className="user-details">
            <span className="mod-header">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="33"
                height="33"
                viewBox="0 0 33 33"
                fill="none"
                onClick={onClosePrevModal}
              >
                <g id="navigate_before">
                  <path
                    id="icon"
                    d="M19.25 24.75L11 16.5L19.25 8.25L21.175 10.175L14.85 16.5L21.175 22.825L19.25 24.75Z"
                    fill="#1D1B20"
                  />
                </g>
              </svg>
              {prevClickValues.rowData?.name || "NA"} -{" "}
              {prevClickValues.rowValue || ""}{" "}
              {prevClickValues.clickedType?.replace(/_/g, " ")}
            </span>
            <span className="mod-regular-text underline">
              +91 {prevClickValues.rowData?.mobile || ""}
            </span>
            <span className="mod-regular-text lowercase underline">
              {prevClickValues.rowData?.email || ""}
            </span>
            <span className="mod-light-text">
              {prevClickValues.rowData?.gym_name || ""}
            </span>
            <span className="mod-light-text underline">
              Shift - {prevClickValues.rowData?.shiftTiming || ""}
            </span>
            <span className="mod-light-text underline">
              Last Checked In -{" "}
              {convertStraight(prevClickValues.rowData?.last_checkin) || "-"}{" "}
              {convertTimeRangeHHMMSS(prevClickValues.rowData?.checkin_time) ||
                ""}{" "}
              {prevClickValues.rowData?.last_checkin_days_ago
                ? `(${prevClickValues.rowData.last_checkin_days_ago?.replace(
                    /_/g,
                    " "
                  )})`
                : ""}
            </span>
          </div>
        </div>

        <button
          type="button"
          className="closeModalBtn"
          onClick={onClosePrevModal}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-x-lg"
            viewBox="0 0 16 16"
          >
            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" />
          </svg>
        </button>
      </div>

      <MemberTableFilters
        user={user}
        allFilters={allFilters}
        setAllFilters={setAllFilters}
        searchFilterApplied={searchFilterApplied}
        onClickSearch={onClickSearch}
        onClickReset={onClickReset}
        MCUTSDate={true}
        isDateRanger={true}
        // onlySearch={true}
        isShiftDropdown={true}
        trainerIdToGetShifts={prevClickValues.userId || ""}
        clickedCard={"members_checkin_under_trainer_shift"}
      />

      {loading ? (
        <ReactVortoxSpinner />
      ) : (
        <div className="tab-view-table-container overflowAuto separatedTable">
          <PaymentLinkTable
            tableData={tbDatas.allData}
            tableColumns={tbColumns}
            tablePagination={tbDatas.pagination}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
          />
        </div>
      )}
    </>
  );
};

export default TrainerMembers;
